import { Box, BoxProps, styled } from "@mui/material";
import { colors } from "../../styles/theme";
import { useDeviceStyles } from "src/hooks/useDeviceStyles";

export type ContainerProps = {
  $type: "texture" | "extra";
  $hasPrice?: boolean;
} & BoxProps;

export const Container = styled(Box, {
  shouldForwardProp: (prop: string) => !prop.includes("$"),
})<ContainerProps>(({ $type, $hasPrice }) => {
  const TEXT_OFFSET = 36; // space reserved for text under icon
  const TEXT_OFFSET_MULTI = 50; // space reserved for text under icon

  const offset = $hasPrice ? TEXT_OFFSET_MULTI : TEXT_OFFSET;

  const { isMobileDevice } = useDeviceStyles();

  return {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start", // 🔥 important fix
    gap: "0px", // 🔥 controls spacing between icon + text

    color: colors.text.v4,
    textAlign: "center",

    paddingLeft: isMobileDevice ? "10px" : "20px",
    paddingRight: isMobileDevice ? "10px" : "20px",
    paddingTop: isMobileDevice ? "10px" : "24px",

    ...($type === "texture" && {
      paddingBottom: `${24 + offset}px`,
    }),

    ...($type !== "texture" && {
      paddingBottom: "24px",
    }),
  };
});
